<template>
  <v-dialog
    v-model="show"
    max-width="490px"
  >
    <v-card>
      <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0 pl-4">{{ fileClass }} upload</v-expansion-panel-header>
            <v-expansion-panel-content>
              Please, upload {{ fileClass ? fileClass.toLowerCase() : '' }} and other document after which your request will be considered by one of company's accountats.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-card-text>
        <v-file-input
          label="Document"
          v-model="file.file"
          @change="onFileChange"
          :loading="isCheckingFiles"
          accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          :rules="[!areFilesIdentical || 'Please, don\'t send 2 identical files']"
        ></v-file-input>
        <br />
        <v-row>
          <v-btn small outlined color="primary" @click="show = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!file.file || isCheckingFiles || areFilesIdentical" @click="postFile">Upload</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { fileToDataUrl } from '@/utils/fileDataUrl'

export default {
  data () {
    return {
      panel: 0,
      file: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      areFilesIdentical: false,
      isCheckingFiles: false,
      fileCheckVersion: 0
    }
  },
  name: 'FileInputDialog',
  props: {
    value: {
      required: true,
      default: false
    },
    request: {
      required: true,
      default: null
    },
    fileClass: {
      required: true,
      default: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        if (!value) {
          this.file = {
            file: null,
            File_Name: '',
            File_Type: ''
          }
          this.areFilesIdentical = false
        }
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async calculateFileSHA256 (file) {
      if (!file || !(file instanceof File)) return null
      const buffer = await file.arrayBuffer()
      const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')
    },
    async calculateBufferSHA256 (bufferData) {
      if (!bufferData) return null
      const hashBuffer = await crypto.subtle.digest('SHA-256', new Uint8Array(bufferData))
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('')
    },
    async checkFilesEquality (newFile) {
      const checkVersion = ++this.fileCheckVersion
      this.areFilesIdentical = false

      const isUploadingConfirmation = this.fileClass === 'Payment confirmation'
      const existingFileName = isUploadingConfirmation
        ? this.request.Agreement_File_Name
        : this.request.Confirmation_File_Name
      const existingFileKind = isUploadingConfirmation ? 'Agreement_File' : 'Confirmation_File'

      if (!existingFileName) {
        this.isCheckingFiles = false
        return
      }

      this.isCheckingFiles = true

      try {
        const [newFileHash, serverFileRes] = await Promise.all([
          this.calculateFileSHA256(newFile),
          this.axios.get(`/api/requests/l_and_d_file/${this.request.Request_ID}/${existingFileKind}`, {
            headers: { Authorization: 'Bearer ' + this.user.token }
          })
        ])

        if (checkVersion !== this.fileCheckVersion) return

        const serverFileBuffer = serverFileRes.data[0]?.File?.data
        if (serverFileBuffer && newFileHash) {
          const serverFileHash = await this.calculateBufferSHA256(serverFileBuffer)

          if (checkVersion !== this.fileCheckVersion) return
          this.areFilesIdentical = newFileHash === serverFileHash
        }
      } catch (error) {
        if (checkVersion !== this.fileCheckVersion) return
        this.$store.dispatch('setError', {
          errorMsg: 'File validation error: ' + error.message
        })
      } finally {
        if (checkVersion === this.fileCheckVersion) {
          this.isCheckingFiles = false
        }
      }
    },
    async onFileChange (e) {
      if (!e) {
        this.file = { file: null, File_Name: '', File_Type: '' }
        this.areFilesIdentical = false
        this.isCheckingFiles = false
        return
      }

      try {
        const res = await fileToDataUrl(e)
        this.file.File_Name = e.name
        this.file.File_Type = e.type
        if (this.file.file) {
          this.file.file.data = res.data
          this.file.file.base64String = res.base64String
        }
        this.checkFilesEquality(e)
      } catch (error) {
        this.file = { file: null, File_Name: '', File_Type: '' }
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    postFile () {
      if (this.isCheckingFiles || this.areFilesIdentical) return

      this.axios.post('/api/requests/l_and_d_file', {
        File: this.file,
        FileClass: this.fileClass,
        Request_ID: this.request.Request_ID,
        Creator_ID: this.request.Creator_ID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'File was uploaded' })
        this.$emit('updateFileInfo')
        this.show = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
